module.exports = "<div class=\"content-top clearfix\">\n  <h1 class=\"al-title\">{{ activePageTitle }}</h1>\n\n  <ul class=\"breadcrumb al-breadcrumb\">\n    <li>\n      <a href=\"#/dashboard\">Home</a></li>\n    <li>{{ activePageTitle }}</li>\n  </ul>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blur_admin/src/app/theme/components/contentTop/contentTop.html
// module id = 810
// module chunks = 2